module.exports = __webpack_public_path__ + "img/dt@2x.6d5e920b.png";